import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import ButtonLarge1 from "components/elements/ButtonLarge1";
import ButtonLarge4 from "components/elements/ButtonLarge4";
import ContentNormal from "components/elements/ContentNormal";
import { AppContext } from "contexts/AppContext";
import { useRef, useState, useEffect, useContext } from "react";

export default function FilterButton({
  label = "Filter",
  onApply,
  onReset,
  children,
}) {
  const { styleGuide } = useContext(AppContext)
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  function handleApply() {
    onApply()
    setOpen(false)
  }

  function handleReset() {
    onReset()
    setOpen(false)
  }

  return (
    <Box ref={rootRef} position={'relative'} display={'flex'} flex={1}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          padding: "9px 20px",
          border: `1px solid ${styleGuide.color6}`,
          borderRadius: 20,
          background: "white",
          textAlign: "left",
          cursor: "pointer",
          display: 'flex',
          justifyContent: 'space-between',
          flex: 1,
          gap: 10,
        }}
      >
        <ContentNormal>{label}</ContentNormal>
        <Box style={{ float: "right" }}>{open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}</Box>
      </button>

      {open && (
        <Box
          padding={2}
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            left: 0,
            width: 300,
            background: "white",
            border: "none",
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            zIndex: 20,
          }}
        >
          {children}

          <Box
            display={'flex'}
            gap={1}
            marginTop={2}
          >
            <ButtonLarge1
              onClick={handleApply}
              style={{ flex: 1, justifyContent: 'center' }}
              showIcon={false}
              translationKey={'_SHOP_APPLY_FILTERS_'}
              fallbackText={'Vis resultater'}
            />
            <ButtonLarge4
              onClick={handleReset}
              showIcon={false}
              translationKey={'_SHOP_RESET_FILTERS_'}
              fallbackText={'Nulstil'}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}